import { useCallback, useEffect, useState } from "react";

type ComparisonId = string | number;

export function useListingCompare() {
  const [comparisonIds, setComparisonIds] = useState<Set<ComparisonId>>(
    () => new Set()
  );
  const [showCompareToast, setShowCompareToast] = useState(false);

  useEffect(() => {
    setShowCompareToast(comparisonIds.size > 0);
  }, [comparisonIds]);

  const hideCompareToast = useCallback(() => {
    setComparisonIds(new Set());
    setShowCompareToast(false);
  }, []);

  const isPlanCompared = useCallback(
    (planId: ComparisonId) => comparisonIds.has(planId),
    [comparisonIds]
  );

  const onComparePress = useCallback((comparisonId: ComparisonId) => {
    setComparisonIds((prev) => {
      const next = new Set(prev);
      if (next.has(comparisonId)) {
        next.delete(comparisonId);
      } else if (next.size < 2) {
        next.add(comparisonId);
      }
      return next;
    });
  }, []);

  return {
    comparisonIds,
    showCompareToast,
    onComparePress,
    isPlanCompared,
    hideCompareToast,
  };
}
